module.exports = __webpack_public_path__ + "static/media/tc.abb6f012.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tc.svg
// module id = 259
// module chunks = 0